import React, { Component } from 'react';
import {  Button, Segment, Form } from 'semantic-ui-react';
import {  pythonApiIp,  } from '../../../../config/constants.js'
import axios from 'axios'
import * as UiConsts from '../../../../config/UiConstants';

class PayTodaysItems extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    payTodays = () => {
        console.log("++++++++:payTodays");

        this.setState({ loading: true });

        axios.post(pythonApiIp + 'payTodaysStockItems', {
            apiKey: "payTodaysStockItems",
            date_range: "today",
            enteredBy: this.props.user.email,
        })
            .then((response) => {
                console.log(response.data);
                this.setState({ loading: false });
                // console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    alert("expenses sent:"+response.data.message);

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    render() {

        return (this.state.loading ? <UiConsts.LoadingComponent /> :<div>
            <h3> PAY TODAYS ITEMS</h3>

            <Segment>
                    <Form fixed onSubmit={this.payTodays}>
                    <Button fluid color='red'>PAY TODAYS STOCK ITEMS</Button>
                    </Form>
                    </Segment>

        </div>);
    }
}

export default PayTodaysItems;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/PayTodaysItems.js